const WEAK_HINT = '须禁用弱口令、默认口令及易猜信息（如 1qaz、年份、Cas@2026、Oracle@123）'
const COMPLEXITY_HINT = '密码须为 12～32 位，包含大写、小写、数字、特殊符号中至少三类'
const HINT = WEAK_HINT + '；' + COMPLEXITY_HINT + '，且不得包含账号、邮箱或手机号'

const WEAK = [
  '1qaz', '2wsx', '3edc', '4rfv', 'qwerty', 'qwertz', 'asdfgh', 'zxcvbn', 'qazwsx',
  'password', 'passw0rd', 'p@ssw0rd', 'admin123', 'admin@123', 'oracle@123', 'oracle123',
  'cas@2026', 'cas2026', '123456', '12345678', '111111', 'abc123', 'iloveyou', 'welcome',
  'letmein', 'qwe123', 'adminadmin', 'root123', 'test123', '1q2w3e', '123qwe', 'qweasd'
]

function compact(value) {
  return String(value || '').replace(/[^a-z0-9]/g, '')
}

export function passwordPolicyHint() {
  return HINT
}

export function validatePasswordPolicy(password, account) {
  if (!password) {
    return HINT
  }
  const lower = password.toLowerCase()
  const folded = compact(lower)
  for (const weak of WEAK) {
    const w = weak.toLowerCase()
    const wCompact = compact(w)
    if (lower.includes(w) || (wCompact.length >= 4 && folded.includes(wCompact))) {
      return WEAK_HINT
    }
  }
  for (let year = 1990; year <= 2040; year++) {
    const y = String(year)
    if (lower.includes(y) || folded.includes(y)) {
      return WEAK_HINT
    }
  }
  const ident = String(account || '').trim().toLowerCase().split('@')[0]
  const idCompact = compact(ident)
  if (ident.length >= 3 && (lower.includes(ident) || (idCompact.length >= 3 && folded.includes(idCompact)))) {
    return '口令不能包含账号、邮箱或手机号等信息'
  }
  if (password.length < 12 || password.length > 32) {
    return COMPLEXITY_HINT
  }
  let classes = 0
  if (/[A-Z]/.test(password)) classes++
  if (/[a-z]/.test(password)) classes++
  if (/[0-9]/.test(password)) classes++
  if (/[^A-Za-z0-9]/.test(password)) classes++
  if (classes < 3) return COMPLEXITY_HINT
  return ''
}
